import React from 'react';
import { Link } from 'react-router-dom';
import { BusinessService } from '../../types';
import styles from './BusinessSection.module.css';

interface BusinessSectionProps {
  services: BusinessService[];
}

const BusinessSection: React.FC<BusinessSectionProps> = ({ services }) => {
  return (
    <section className={styles.businessSection}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionSubtitle}>OUR BUSINESS</span>
          <h2 className={styles.sectionTitle}>주요사업</h2>
          <p className={styles.sectionDescription}>
            승강기 안전관리를 위한 주요업무 운영지침을 안내합니다. 궁금하신 사항은 무엇이든지
          </p>
        </div>

        <div className={styles.serviceGrid}>
          {services.map((service) => (
            <div key={service.id} className={styles.serviceCard}>
              <Link to={service.href}>
                <i
                  className={styles.serviceIcon}
                  style={{ backgroundImage: `url(${service.icon})` }}
                />
                <h3
                  className={styles.serviceTitle}
                  dangerouslySetInnerHTML={{ __html: service.title }}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessSection;
